module.exports = __webpack_public_path__ + "static/media/meme_15.f4308389.jpg";